import FooterComponent from './FooterComponent.vue'

export default FooterComponent



// WEBPACK FOOTER //
// ./client/components/FooterComponent/index.js